! function() {
    "use strict";
    var e = {
            5837: function(e, t, r) {
                r.d(t, {
                    hF: function() {
                        return o
                    }
                });
                var c = r(4105);
                document.getElementById("nav-wrapper");
                const n = document.querySelectorAll(".predictive-search"),
                    s = document.getElementById("overlay"),
                    o = () => {
                        s.classList.remove("open"), document.body.classList.remove("active", "search"), n.forEach((e => {
                            e.classList.remove("open"), (0, c.zx)(e.closest(".predictive-search-wrapper"))
                        }))
                    }
            },
            4105: function(e, t, r) {
                r.d(t, {
                    Ds: function() {
                        return o
                    },
                    St: function() {
                        return l
                    },
                    gp: function() {
                        return s
                    },
                    zx: function() {
                        return a
                    }
                });
                let c = () => {};
                const n = e => {
                        "Escape" === e.key && (c(), window.removeEventListener("keydown", n))
                    },
                    s = function() {
                        let e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
                            t = arguments.length > 1 ? arguments[1] : void 0;
                        t && (c = t), e && window.addEventListener("keydown", n), e || window.removeEventListener("keydown", n)
                    };

                function o(e, t) {
                    const r = this;
                    let c;
                    return function() {
                        for (var n = arguments.length, s = new Array(n), o = 0; o < n; o++) s[o] = arguments[o];
                        clearTimeout(c), c = setTimeout((function() {
                            return e.apply(r, s)
                        }), t)
                    }
                }
                document.querySelectorAll(".local-scroll").forEach((e => {
                    e.addEventListener("click", (e => {
                        e.preventDefault(), e.stopPropagation();
                        const t = e.target.getAttribute("href");
                        (e => {
                            Math.easeInOutQuad = function(e, t, r, c) {
                                return (e /= c / 2) < 1 ? r / 2 * e * e + t : -r / 2 * (--e * (e - 2) - 1) + t
                            };
                            const t = document.getElementById("grid-archive-header"),
                                r = document.getElementById("nav-wrapper");
                            let c = 0,
                                n = 0;
                            t && (c = t.offsetHeight + 50), r && (n = r.offsetHeight + 50);
                            const s = e.offsetTop - c - n,
                                o = window.scrollY,
                                i = s - o;
                            let l = 0;
                            const a = () => {
                                l += 5;
                                const e = Math.easeInOutQuad(l, o, i, 200);
                                window.scrollTo(0, e), l < 200 && setTimeout(a, 5)
                            };
                            a()
                        })(document.querySelector(t))
                    }))
                }));
                const i = {};

                function l(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
                    const r = function(e) {
                            return Array.from(e.querySelectorAll('summary, a[href], button:not([disabled]), [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'))
                        }(e),
                        c = r[0],
                        n = r[r.length - 1];
                    a(), i.focusin = t => {
                        t.target !== e && t.target !== n && t.target !== c || document.addEventListener("keydown", i.keydown)
                    }, i.focusout = function() {
                        document.removeEventListener("keydown", i.keydown)
                    }, i.keydown = function(t) {
                        "TAB" === t.code.toUpperCase() && (t.target !== n || t.shiftKey || (t.preventDefault(), c.focus()), t.target !== e && t.target !== c || !t.shiftKey || (t.preventDefault(), n.focus()))
                    }, document.addEventListener("focusout", i.focusout), document.addEventListener("focusin", i.focusin), t.focus()
                }

                function a(e) {
                    document.removeEventListener("focusin", i.focusin), document.removeEventListener("focusout", i.focusout), document.removeEventListener("keydown", i.keydown), e && e.focus()
                }
            }
        },
        t = {};

    function r(c) {
        var n = t[c];
        if (void 0 !== n) return n.exports;
        var s = t[c] = {
            exports: {}
        };
        return e[c](s, s.exports, r), s.exports
    }
    r.d = function(e, t) {
            for (var c in t) r.o(t, c) && !r.o(e, c) && Object.defineProperty(e, c, {
                enumerable: !0,
                get: t[c]
            })
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t)
        },
        function() {
            var e = r(4105),
                t = r(5837);
            const c = document.getElementById("nav-wrapper"),
                n = document.getElementById("overlay"),
                s = () => {
                    (0, t.hF)(), c.removeEventListener("click", u)
                },
                o = () => {
                    const r = document.querySelectorAll(".search-input"),
                        c = document.querySelectorAll(".predictive-search"),
                        o = document.querySelectorAll(".predictive-search__mobile-close");
                    r.forEach((t => t.addEventListener("keyup", (0, e.Ds)((function(e) {
                        if (9 != e.which) {
                            const t = e.target.value,
                                r = e.target.getAttribute("data-predictive-search"),
                                c = document.querySelector('#predictive-search[data-predictive-search="' + r + '"]'),
                                s = c.querySelector(".search-sidebar__initial"),
                                o = c.querySelector(".search-sidebar__results");
                            c.classList.add("searching"), "" !== t ? fetch(`/search/suggest.json?q=${t}&resources[type]=product,collection,article&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title`).then((e => e.json())).then((e => {
                                const r = e.resources.results.products,
                                    i = e.resources.results.collections,
                                    l = e.resources.results.articles;
                                if (c.classList.add("open"), n.classList.add("open"), r.length > 0) {
                                    c.querySelector(".no-results-notice").style.display = "none", c.querySelector(".search-products__results-grid").style.display = "grid", c.querySelector(".search-products").style.display = "block", c.querySelector(".search-products__row").style.display = "none";
                                    let e = document.createElement("div");
                                    e.classList.add("search-products"), r.forEach((t => {
                                      if (t.tags && t.tags.includes("hidden-from-search")) {
                                            // Skip this product if it has the "hidden-from-search" tag
                                            return;
                                        }
                                        var r;
                                        r = t.featured_image.url ? `<img src="${t.featured_image.url}&width=400" alt="${t.title}" srcset="${t.featured_image.url}&width=352 352w" width="400" height="469" class="img-absolute" loading="lazy">` : '<svg class="img-placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M375.5 345.2c0-.1 0-.1 0 0 0-.1 0-.1 0 0-1.1-2.9-2.3-5.5-3.4-7.8-1.4-4.7-2.4-13.8-.5-19.8 3.4-10.6 3.6-40.6 1.2-54.5-2.3-14-12.3-29.8-18.5-36.9-5.3-6.2-12.8-14.9-15.4-17.9 8.6-5.6 13.3-13.3 14-23 0-.3 0-.6.1-.8.4-4.1-.6-9.9-3.9-13.5-2.1-2.3-4.8-3.5-8-3.5h-54.9c-.8-7.1-3-13-5.2-17.5-6.8-13.9-12.5-16.5-21.2-16.5h-.7c-8.7 0-14.4 2.5-21.2 16.5-2.2 4.5-4.4 10.4-5.2 17.5h-48.5c-3.2 0-5.9 1.2-8 3.5-3.2 3.6-4.3 9.3-3.9 13.5 0 .2 0 .5.1.8.7 9.8 5.4 17.4 14 23-2.6 3.1-10.1 11.7-15.4 17.9-6.1 7.2-16.1 22.9-18.5 36.9-2.2 13.3-1.2 47.4 1 54.9 1.1 3.8 1.4 14.5-.2 19.4-1.2 2.4-2.3 5-3.4 7.9-4.4 11.6-6.2 26.3-5 32.6 1.8 9.9 16.5 14.4 29.4 14.4h176.8c12.9 0 27.6-4.5 29.4-14.4 1.2-6.5-.5-21.1-5-32.7zm-97.7-178c.3-3.2.8-10.6-.2-18 2.4 4.3 5 10.5 5.9 18h-5.7zm-36.3-17.9c-1 7.4-.5 14.8-.2 18h-5.7c.9-7.5 3.5-13.7 5.9-18zm4.5-6.9c0-.1.1-.2.1-.4 4.4-5.3 8.4-5.8 13.1-5.8h.7c4.7 0 8.7.6 13.1 5.8 0 .1 0 .2.1.4 3.2 8.9 2.2 21.2 1.8 25h-30.7c-.4-3.8-1.3-16.1 1.8-25zm-70.7 42.5c0-.3 0-.6-.1-.9-.3-3.4.5-8.4 3.1-11.3 1-1.1 2.1-1.7 3.4-2.1l-.6.6c-2.8 3.1-3.7 8.1-3.3 11.6 0 .2 0 .5.1.8.3 3.5.9 11.7 10.6 18.8.3.2.8.2 1-.2.2-.3.2-.8-.2-1-9.2-6.7-9.8-14.4-10-17.7 0-.3 0-.6-.1-.8-.3-3.2.5-7.7 3-10.5.8-.8 1.7-1.5 2.6-1.9h155.7c1 .4 1.9 1.1 2.6 1.9 2.5 2.8 3.3 7.3 3 10.5 0 .2 0 .5-.1.8-.3 3.6-1 13.1-13.8 20.1-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .3-.1 13.5-7.5 14.3-17.5 14.6-21.3 0-.3 0-.5.1-.8.4-3.5-.5-8.5-3.3-11.6l-.6-.6c1.3.4 2.5 1.1 3.4 2.1 2.6 2.9 3.5 7.9 3.1 11.3 0 .3 0 .6-.1.9-1.5 20.9-23.6 31.4-65.5 31.4h-43.8c-41.8 0-63.9-10.5-65.4-31.4zm91 89.1h-7c0-1.5 0-3-.1-4.2-.2-12.5-2.2-31.1-2.7-35.1h3.6c.8 0 1.4-.6 1.4-1.4v-14.1h2.4v14.1c0 .8.6 1.4 1.4 1.4h3.7c-.4 3.9-2.4 22.6-2.7 35.1v4.2zm65.3 11.9h-16.8c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h16.8v2.8h-62.2c0-.9-.1-1.9-.1-2.8h33.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-33.9c-.1-3.2-.1-6.3-.1-9h62.5v9zm-12.5 24.4h-6.3l.2-1.6h5.9l.2 1.6zm-5.8-4.5l1.6-12.3h2l1.6 12.3h-5.2zm-57-19.9h-62.4v-9h62.5c0 2.7 0 5.8-.1 9zm-62.4 1.4h62.4c0 .9-.1 1.8-.1 2.8H194v-2.8zm65.2 0h7.3c0 .9.1 1.8.1 2.8H259c.1-.9.1-1.8.1-2.8zm7.2-1.4h-7.2c.1-3.2.1-6.3.1-9h7c0 2.7 0 5.8.1 9zm-7.7-66.7v6.8h-9v-6.8h9zm-8.9 8.3h9v.7h-9v-.7zm0 2.1h9v2.3h-9v-2.3zm26-1.4h-9v-.7h9v.7zm-9 3.7v-2.3h9v2.3h-9zm9-5.9h-9v-6.8h9v6.8zm-119.3 91.1c-2.1-7.1-3-40.9-.9-53.6 2.2-13.5 11.9-28.6 17.8-35.6 5.6-6.5 13.5-15.7 15.7-18.3 11.4 6.4 28.7 9.6 51.8 9.6h6v14.1c0 .8.6 1.4 1.4 1.4h5.4c.3 3.1 2.4 22.4 2.7 35.1 0 1.2.1 2.6.1 4.2h-63.9c-.8 0-1.4.6-1.4 1.4v16.1c0 .8.6 1.4 1.4 1.4H256c-.8 11.8-2.8 24.7-8 33.3-2.6 4.4-4.9 8.5-6.9 12.2-.4.7-.1 1.6.6 1.9.2.1.4.2.6.2.5 0 1-.3 1.3-.8 1.9-3.7 4.2-7.7 6.8-12.1 5.4-9.1 7.6-22.5 8.4-34.7h7.8c.7 11.2 2.6 23.5 7.1 32.4.2.5.8.8 1.3.8.2 0 .4 0 .6-.2.7-.4 1-1.2.6-1.9-4.3-8.5-6.1-20.3-6.8-31.1H312l-2.4 18.6c-.1.4.1.8.3 1.1.3.3.7.5 1.1.5h9.6c.4 0 .8-.2 1.1-.5.3-.3.4-.7.3-1.1l-2.4-18.6H333c.8 0 1.4-.6 1.4-1.4v-16.1c0-.8-.6-1.4-1.4-1.4h-63.9c0-1.5 0-2.9.1-4.2.2-12.7 2.3-32 2.7-35.1h5.2c.8 0 1.4-.6 1.4-1.4v-14.1h6.2c23.1 0 40.4-3.2 51.8-9.6 2.3 2.6 10.1 11.8 15.7 18.3 5.9 6.9 15.6 22.1 17.8 35.6 2.2 13.4 2 43.2-1.1 53.1-1.2 3.9-1.4 8.7-1 13-1.7-2.8-2.9-4.4-3-4.6-.2-.3-.6-.5-.9-.6h-.5c-.2 0-.4.1-.5.2-.6.5-.8 1.4-.3 2 0 0 .2.3.5.8 1.4 2.1 5.6 8.4 8.9 16.7h-42.9v-43.8c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v44.9c0 .1-.1.2-.1.3 0 .1 0 .2.1.3v9c-1.1 2-3.9 3.7-10.5 3.7h-7.5c-.4 0-.7.3-.7.7 0 .4.3.7.7.7h7.5c5 0 8.5-.9 10.5-2.8-.1 3.1-1.5 6.5-10.5 6.5H210.4c-9 0-10.5-3.4-10.5-6.5 2 1.9 5.5 2.8 10.5 2.8h67.4c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-67.4c-6.7 0-9.4-1.7-10.5-3.7v-54.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v43.8h-43.6c4.2-10.2 9.4-17.4 9.5-17.5.5-.6.3-1.5-.3-2s-1.5-.3-2 .3c-.1.2-1.4 2-3.2 5 .1-4.9-.4-10.2-1.1-12.8zm221.4 60.2c-1.5 8.3-14.9 12-26.6 12H174.4c-11.8 0-25.1-3.8-26.6-12-1-5.7.6-19.3 4.6-30.2H197v9.8c0 6.4 4.5 9.7 13.4 9.7h105.4c8.9 0 13.4-3.3 13.4-9.7v-9.8h44c4 10.9 5.6 24.5 4.6 30.2z"/><path d="M286.1 359.3c0 .4.3.7.7.7h14.7c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-14.7c-.3 0-.7.3-.7.7zm5.3-145.6c13.5-.5 24.7-2.3 33.5-5.3.4-.1.6-.5.4-.9-.1-.4-.5-.6-.9-.4-8.6 3-19.7 4.7-33 5.2-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm-11.3.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H242c-19.9 0-35.3-2.5-45.9-7.4-.4-.2-.8 0-.9.3-.2.4 0 .8.3.9 10.8 5 26.4 7.5 46.5 7.5h38.1zm-7.2 116.9c.4.1.9.1 1.4.1 1.7 0 3.4-.7 4.7-1.9 1.4-1.4 1.9-3.2 1.5-5-.2-.8-.9-1.2-1.7-1.1-.8.2-1.2.9-1.1 1.7.3 1.2-.4 2-.7 2.4-.9.9-2.2 1.3-3.4 1-.8-.2-1.5.3-1.7 1.1s.2 1.5 1 1.7z"/><path d="M275.5 331.6c-.8 0-1.4.6-1.5 1.4 0 .8.6 1.4 1.4 1.5h.3c3.6 0 7-2.8 7.7-6.3.2-.8-.4-1.5-1.1-1.7-.8-.2-1.5.4-1.7 1.1-.4 2.3-2.8 4.2-5.1 4zm5.4 1.6c-.6.5-.6 1.4-.1 2 1.1 1.3 2.5 2.2 4.2 2.8.2.1.3.1.5.1.6 0 1.1-.3 1.3-.9.3-.7-.1-1.6-.8-1.8-1.2-.5-2.2-1.2-3-2.1-.6-.6-1.5-.6-2.1-.1zm-38.2 12.7c.5 0 .9 0 1.4-.1.8-.2 1.3-.9 1.1-1.7-.2-.8-.9-1.3-1.7-1.1-1.2.3-2.5-.1-3.4-1-.4-.4-1-1.2-.8-2.4.2-.8-.3-1.5-1.1-1.7-.8-.2-1.5.3-1.7 1.1-.4 1.8.1 3.7 1.5 5 1.2 1.2 2.9 1.9 4.7 1.9z"/><path d="M241.2 349.6h.3c.8 0 1.4-.7 1.4-1.5s-.7-1.4-1.5-1.4c-2.3.1-4.6-1.7-5.1-4-.2-.8-.9-1.3-1.7-1.1-.8.2-1.3.9-1.1 1.7.7 3.5 4.1 6.3 7.7 6.3zm-9.7 3.6c.2 0 .3 0 .5-.1 1.6-.6 3-1.6 4.2-2.8.5-.6.5-1.5-.1-2s-1.5-.5-2 .1c-.8.9-1.8 1.6-3 2.1-.7.3-1.1 1.1-.8 1.8 0 .6.6.9 1.2.9z"/></svg>';
                                        const c = `\n                    <div class="card-product card">\n                      <a href="${t.url}">\n                        <figure role="none">\n                          ${r}\n                        </figure>\n                        <div class="card__content">\n                          <p class="card__title text-lg">\n                              ${t.title}\n                          </p>\n                        </div>\n                      </a>\n                    `;
                                        e.innerHTML += c
                                    })), c.querySelector(".search-products__results-grid").innerHTML = e.innerHTML
                                } else c.querySelector(".no-results-notice").style.display = "flex", c.querySelector(".search-products").style.display = "none";
                                let a = c.querySelector(".collection-search");
                                i.length > 0 ? (c.querySelector(".search-sidebar__collections").innerHTML = window.searchStrings.title_results_collection, a.innerHTML = "", i.forEach((e => {
                                    let r = document.createElement("li"),
                                        c = document.createElement("a");
                                    c.setAttribute("href", e.url);
                                    const n = e.title;
                                    let s = new RegExp("(" + t + ")", "i"),
                                        o = n.replace(s, "<b>$1</b>");
                                    c.innerHTML = o, r.appendChild(c), a.appendChild(r)
                                }))) : (c.querySelector(".search-sidebar__collections").innerHTML = window.searchStrings.title_no_results_collection, a.innerHTML = "");
                                let d = c.querySelector(".article-search");
                                l.length > 0 && d ? (c.querySelector(".search-sidebar__articles").innerHTML = window.searchStrings.title_results_article, d.innerHTML = "", l.forEach((e => {
                                    let r = document.createElement("li"),
                                        c = document.createElement("a");
                                    c.setAttribute("href", e.url);
                                    const n = e.title;
                                    let s = new RegExp("(" + t + ")", "i"),
                                        o = n.replace(s, "<b>$1</b>");
                                    c.innerHTML = o, r.appendChild(c), d.appendChild(r)
                                }))) : (c.querySelector(".search-sidebar__articles").innerHTML = window.searchStrings.title_no_results_article, d.innerHTML = "");
let u = c.querySelector(".searches-search");
let hasResults = false; // Flag to track if valid results are found

r.length > 0 && u ? (
    c.querySelector(".search-sidebar__searches").innerHTML = window.searchStrings.title_results, 
    u.innerHTML = "", 
    r.forEach((e) => {
        // Check if the result has the 'hidden-from-search' tag
        if (e.tags && e.tags.includes("hidden-from-search")) {
            return; // Skip this result if it's hidden
        }

        hasResults = true; // Mark that we have found a valid result

        let r = document.createElement("li"),
            c = document.createElement("a");
        c.setAttribute("href", e.url);
        const n = e.title;
        let s = new RegExp("(" + t + ")", "i"),
            o = n.replace(s, "<b>$1</b>");
        c.innerHTML = o, r.appendChild(c), u.appendChild(r);
    })
) : (
    // If no results were found or all results are hidden, display 'no results'
    c.querySelector(".search-sidebar__searches").innerHTML = window.searchStrings.title_no_results, 
    u.innerHTML = ""
);

// If no valid results, show the "no results" message
if (!hasResults) {
    c.querySelector(".search-sidebar__searches").innerHTML = window.searchStrings.title_no_results;
}

s.style.display = "none";
o.style.display = "block";
c.classList.remove("searching");




                              
                            })) : (s.style.display = "block", o.style.display = "none", c.querySelector(".no-results-notice").style.display = "none", c.querySelector(".search-products").style.display = "block", c.querySelector(".search-products__results-grid").style.display = "none", c.querySelector(".search-products__row").style.display = "block", c.classList.remove("searching"))
                        }
                    }), 300)))), n.addEventListener("click", (() => {
                        (0, t.hF)(), (0, e.gp)(!1)
                    })), o.forEach((e => {
                        e.addEventListener("click", (() => {
                            s()
                        }))
                    })), c.forEach((e => {
                        e.addEventListener("click", (e => {
                            e.stopPropagation()
                        }))
                    }))
                };
            o();
            const i = e => {
                    document.getElementById("nav-wrapper").querySelectorAll("details.megamenu-open > summary").forEach((e => {
                        e.classList.remove("active"), e.parentNode.removeAttribute("open")
                    }))
                },
                l = t => {
                    const r = t.getAttribute("data-predictive-search");
                    if (r) {
                        const t = document.querySelector('#predictive-search[data-predictive-search="' + r + '"]'),
                            o = document.querySelectorAll(".predictive-search");
                        if (o && o.forEach((e => {
                                e.classList.remove("open")
                            })), t) {
                            const r = t.closest(".predictive-search-wrapper");
                            t.classList.add("open"), document.body.classList.add("active", "search"), (0, e.gp)(!0, s), c.addEventListener("click", u), n.classList.add("open"), setTimeout((() => {
                                t.querySelector("#SearchMobile.search-input").focus()
                            }), "100"), (0, e.St)(r, t)
                        }
                    }
                },
                a = () => {
                    document.querySelectorAll(".search-trigger").forEach((e => {
                        e.addEventListener("click", (() => {
                            l(e), i()
                        })), e.addEventListener("focus", (() => {
                            l(e), i()
                        }))
                    }))
                };
            a();
            const d = () => {
                document.querySelectorAll(".button.search-input").forEach((e => {
                    e.addEventListener("click", (e => {
                        "" === e.target.parentNode.querySelector('input[type="search"]').value && (e.preventDefault(), e.stopPropagation())
                    }))
                }))
            };
            d();
            const u = e => {
                window.matchMedia("(min-width: 1024px)").matches && (e.target.classList.contains("search-trigger") || e.target.classList.contains("search-icon") || s())
            };
            Shopify.designMode && document.addEventListener("shopify:section:load", (() => {
                d(), a(), o()
            }))
        }()
}();